import common from './cn/common';
import errors from './cn/errors';
import home from './cn/home';
import center from './cn/center';
import custom from './cn/custom';

export default {
    home: {
        ...home
    },
    center: {
        ...center
    },
    lang: {
        ...common,
        ...errors
    },
    custom: {
        ...custom
    }
};
